import { render, staticRenderFns } from "./nomenu_container.vue?vue&type=template&id=74f5a788&scoped=true"
import script from "./nomenu_container.vue?vue&type=script&lang=js"
export * from "./nomenu_container.vue?vue&type=script&lang=js"
import style0 from "./nomenu_container.vue?vue&type=style&index=0&id=74f5a788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f5a788",
  null
  
)

export default component.exports